import { render, staticRenderFns } from "./AccountSettingsSecurity.vue?vue&type=template&id=39c6e879&scoped=true"
import script from "./AccountSettingsSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSettingsSecurity.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsSecurity.vue?vue&type=style&index=0&id=39c6e879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6e879",
  null
  
)

export default component.exports